import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clients-review',
  templateUrl: './clients-review.component.html',
  styleUrls: ['./clients-review.component.css']
})
export class ClientsReviewComponent implements OnInit {
  slideConfig = {dots: false, pauseOnHover: true, focusOnSelect: false, draggable: true, swipe: true, autoplay: false,"slidesToShow": 2, "slidesToScroll": 1, speed:600, "autoplaySpeed": 5000, cssEase: 'cubic-bezier(0.250,  0.060, 0.050, 0.040)'};

  constructor() { }

  ngOnInit() {
  }

}
